class PageLoaded {
    constructor() {
        this._body        = document.body;
        this._page        = document.getElementsByClassName('js-page-loader')[0];
        this._domLoaded   = false;
        this._imageLoaded = false;

        this._body.style.overflow = 'hidden';
    }

    wait(callback) {
        document.addEventListener('DOMContentLoaded', () => {
            this._domLoaded = true;

            this._remove(callback);
        });
        window.addEventListener("load", () => {
            this._imageLoaded = true;

            this._remove(callback);
        });
    }

    _remove(callback) {
        if (this._domLoaded && this._imageLoaded) {
            callback();

            // Wait end all the script
            setTimeout(() => {
                this._body.style.overflow = '';
                this._page.parentElement.removeChild(this._page);
            }, 500);
        }

    }
}

module.exports = PageLoaded;